import { useQuery, UseQueryOptions } from 'react-query';

import { DealInvoice } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDealInvoicesQuery(
	guid: string | undefined,
	options?: Omit<UseQueryOptions<DealInvoice[], unknown, DealInvoice[]>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Deal.Invoices(guid),
		() => AxiosUtils.getResponseData<DealInvoice[]>(api.get(CerebroApiEndpoints.Deals.Invoices(guid))),
		options
	);
}
